var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Period } from "./../models/V1/SubmissionPeriods/UK/Period";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { VATDeclaration } from "./../models/V1/SubmissionPeriods/UK/VATDeclaration";
export class SubmissionPeriodsUK {
  /**
   * Creates an instance of SubmissionPeriodsUK.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof SubmissionPeriodsUK
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetUKPeriodsRq_ _getUKPeriodsRq
   * @returns Promise<GetUKPeriodsRq_>
   * @memberof SubmissionPeriodsUK
   */
  getUKPeriods(pGetUKPeriodsRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/submissionperiods/{submissionPeriodId}/uk/periods",
      "GET",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pGetUKPeriodsRq.submissionPeriodId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: Period, isArray: true },
        { statusCode: 401, clazz: ApiError },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetUkVatDeclarationRq_ _getUkVatDeclarationRq
   * @returns Promise<GetUkVatDeclarationRq_>
   * @memberof SubmissionPeriodsUK
   */
  getUkVatDeclaration(pGetUkVatDeclarationRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/submissionperiods/{submissionPeriodId}/uk/vatdeclaration",
      "GET",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pGetUkVatDeclarationRq.submissionPeriodId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: VATDeclaration },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SubmitUKReturnRq_ _submitUKReturnRq
   * @returns Promise<SubmitUKReturnRq_>
   * @memberof SubmissionPeriodsUK
   */
  submitUKReturn(pSubmitUKReturnRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/submissionperiods/{submissionPeriodId}/uk/submit",
      "POST",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([{ name: "submissionPeriodId", value: pSubmitUKReturnRq.submissionPeriodId, required: true }]);
    client.addBody({ value: pSubmitUKReturnRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200 },
        { statusCode: 400, clazz: ApiError },
        { statusCode: 401, clazz: ApiError },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
